import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CALL_STATUS } from "./constants";
import withdrawalsAPI from "../../api/withdrawals";

const initialState = {
    status: CALL_STATUS.IDLE,
    error: null,
    requests: [],
    users: {}
};

export const fetchWithdrawalsWithUsers = createAsyncThunk(
    'withdrawals/FETCH_ALL',
    async (token, { rejectWithValue }) => {
        try {
            const requests = await withdrawalsAPI.getAdminWithdrawals(token);

            const userIds = [...new Set(requests.map(r => r.userId))];

            const usersMap = {};
            if (userIds.length > 0) {
                const usersDetails = await withdrawalsAPI.getUsersDetails(userIds, token);
                usersDetails.forEach(user => {
                    usersMap[user.id] = user;
                });
            }

            return { requests, usersMap };
        } catch (err) {
            return rejectWithValue(err.message);
        }
    }
);

const withdrawalsSlice = createSlice({
    name: "withdrawals",
    initialState,
    reducers: {
        reset: () => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchWithdrawalsWithUsers.pending, (state) => {
                state.status = CALL_STATUS.PENDING;
            })
            .addCase(fetchWithdrawalsWithUsers.fulfilled, (state, action) => {
                state.status = CALL_STATUS.SUCCESS;
                state.requests = action.payload.requests;
                state.users = action.payload.usersMap;
            })
            .addCase(fetchWithdrawalsWithUsers.rejected, (state, action) => {
                state.status = CALL_STATUS.ERROR;
                state.error = action.payload;
            });
    }
});

export default withdrawalsSlice.reducer;